import { MedioDrug } from "@types";

const sortByPrice = (generics: MedioDrug[]) =>
  generics.sort((a, b) => {
    return a.priceDifference - b.priceDifference;
  });

export { sortByPrice };
